import { render, staticRenderFns } from "./OculisticaForm.vue?vue&type=template&id=450ef76c&scoped=true&"
import script from "./OculisticaForm.vue?vue&type=script&lang=js&"
export * from "./OculisticaForm.vue?vue&type=script&lang=js&"
import style0 from "./OculisticaForm.vue?vue&type=style&index=0&id=450ef76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ef76c",
  null
  
)

export default component.exports